<template lang="pug">
div
  AuthHeader
  main
    Promo
  PromoFooter
  Registration(:showHeading="false")
</template>

<script>
import UserMixin from "@chronos/frontend-base/src/mixins/user/UserMixin";
import AuthHeader from "@static_promo_pages/common/components/auth-header/vue/AuthHeader.vue";
import PromoFooter from "@static_promo_pages/common/components/footer/vue/Footer.vue";
import Registration from "@chronos/frontend-base/src/components/register/mygames/ProjectReg";
import Promo from "./blocks/promo/Promo";
import OldUserPopupMixin from "@static_promo_pages/common/components/old-user-popup/mixins/OldUserPopupMixin";
export default {
  name: "PromoIndex",

  components: {
    Promo,
    AuthHeader,
    PromoFooter,
    Registration,
  },

  mixins: [UserMixin, OldUserPopupMixin],

  data() {
    return {
      promo_name: "luckybox",
    };
  },

  created() {
    document.addEventListener("init_vue_components", () => {
      this.initPromo();
    });
  },

  methods: {
    async initPromo() {
      await this.$store.dispatch("global/auth", { profile_fields: ["registration_url"] });
    },
  },
};
</script>
